import { Typography } from '@mui/material'
import React from 'react'

import { PanelBox } from '../default'
import { PlanGroupsTable } from '../tables'

/**
 * @description Renders a panel for managing plan groups.
 *
 * @author Maria Eduarda Franke
 * @returns {React.Component} The rendered component.
 */
const PlanGroupsPanel = () => {

    return (
        <PanelBox>
            <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
                Gerenciar Grupos de Planos
            </Typography>
            <PlanGroupsTable />
        </PanelBox>
    )
}

export default PlanGroupsPanel